<div
  class="accessibility-text toast-announcement"
  [attr.role]="toastDetails?.type === ToastStatusTypes.ERROR ? 'alert' : 'status'"
  [attr.aria-live]="toastDetails?.type === ToastStatusTypes.ERROR ? 'assertive' : 'polite'"
  aria-atomic="true">
  @if (shouldShowToast()) {
    <span [innerHTML]="toastDetails.message | translate"></span>
  }
</div>
@if (shouldShowToast()) {
  <div
    class="go-react-toast"
    [ngClass]="{'toast-mobile': UADetect.isMobile() }"
    >
    <div
      class="toast-content"
		[ngClass]="{
			'success': toastDetails.type === ToastStatusTypes.SUCCESS,
			'warning': toastDetails.type === ToastStatusTypes.WARNING,
			'error': toastDetails.type === ToastStatusTypes.ERROR
		}">
      <span class="toast-icon">
        @if (toastDetails.type === ToastStatusTypes.SUCCESS) {
          <i class="ficon-app-checkmark-circle-outline"
            >
          </i>
        }
        @if (toastDetails.type === ToastStatusTypes.WARNING) {
          <i class="ficon-app-information-outline"
            role="img"
            [attr.aria-label]="'common_information' | translate"
            >
          </i>
        }
        @if (toastDetails.type === ToastStatusTypes.ERROR) {
          <i class="ficon-app-warning-circle-outline"
            >
          </i>
        }
      </span>
      <p class="toast-message-wrap">
        <span class="toast-message" [innerHTML]="toastDetails.message | translate"></span>
        @if (toastDetails.actionLink) {
          <span>
            &nbsp;<button type="button" class="action-link goreact-btn btn-none" (click)="toastDetails.actionLink.action(); closeToast()" [innerHTML]="toastDetails.actionLink.title | translate"></button>
          </span>
        }
      </p>
      @if (toastDetails.undo) {
        <button
          type="button"
          class="btn-none undo-btn tertiary-btn"
          (click)="undoAction()"
          translate="common_undo">
        </button>
      }
      <button
        type="button"
        class="btn-none close-btn"
        [attr.aria-label]="'common_close' | translate"
        (click)="closeToast()">
        <i class="ficon-app-x"></i>
      </button>
    </div>
  </div>
}
